<template>
  <ion-modal :is-open="display" @willPresent="onWillPresent">
    <ion-header>
      <ion-toolbar>
        <ion-title>Identificación</ion-title>
        <ion-buttons slot="end">
          <ion-button @click="close">Cerrar</ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <section class="wrapper">
        <ion-list>
          <ion-item>
            <ion-input label="NIF / NIE / CIF *"
                       label-placement="floating"
                       placeholder="Introduzca su identificación"
                       :error-text="v$.nif.$errors[0]?.$message"
                       :class="{'ion-invalid ion-touched': v$.nif.$error}"
                       v-model="user.nif"></ion-input>
          </ion-item>

          <ion-item>
            <ion-input label="Email *"
                       label-placement="floating"
                       placeholder="Introduzca su correo electrónico"
                       type="email"
                       :error-text="v$.email.$errors[0]?.$message"
                       :class="{'ion-invalid ion-touched': v$.email.$error}"
                       v-model="user.email"></ion-input>
          </ion-item>

          <ion-item>
            <ion-input label="Teléfono *"
                       label-placement="floating"
                       placeholder="Introduzca su teléfono"
                       type="tel"
                       :error-text="v$.phone.$errors[0]?.$message"
                       :class="{'ion-invalid ion-touched': v$.phone.$error}"
                       v-model="user.phone"></ion-input>
          </ion-item>
        </ion-list>

        <ion-button expand="block" :disabled="v$.$invalid" @click="validate">Enviar</ion-button>
      </section>
    </ion-content>
  </ion-modal>
</template>

<script lang="ts" setup>
import { reactive, defineProps, defineEmits } from 'vue'
import { IonTitle, IonButton, IonButtons, IonToolbar, IonHeader, IonContent,
         IonModal, IonInput, IonItem, IonList } from '@ionic/vue'

import { useVuelidate } from '@vuelidate/core'
import { required, email } from '@/modules/i18n-validators'
import { UserCredentials } from '@/models/UserCredentials'

defineProps<{
  display: boolean
}>()

const emit = defineEmits<{
  (e: 'update:display', value: boolean): void,
  (e: 'save', user: UserCredentials): void
}>()

const userInit: UserCredentials = {
  nif: '',
  email: '',
  phone: ''
}

const user = reactive<UserCredentials>({ ...userInit })

const rules = {
  nif: { required },
  email: { required, email },
  phone: { required }
}

const v$ = useVuelidate(rules, user, { $lazy: false, $autoDirty: true })

const validate = async () => {
  const valid = await v$.value.$validate()
  if (!valid) return

  save()
}

const save = () => {
  emit('save', user)
  close()
}

const close = () => {
  emit('update:display', false)
}

const onWillPresent = () => {
  Object.assign(user, userInit)
  v$.value.$reset()
}

</script>

<style lang="scss" scoped>
  @import '@/theme/breakpoints';

  .wrapper {
    height: 90%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  ion-header, ion-content {
    @media ((prefers-color-scheme: dark) and (min-width: $breakpoint-md)) {
      border: 1px dotted var(--ion-color-dark-tint);
    }
  }
</style>
